<template>
  <div class="two-box" v-if="teacherList && teacherList.length > 0">
    <div class="title">
      <p><slot>师资力量</slot></p>
      <el-pagination
        class="redPage"
        :current-page="pageNum"
        @prev-click="toprev"
        @next-click="tonext"
        :page-size="4"
        layout="prev, next"
        :total="total"
      >
      </el-pagination>
    </div>
    <div class="carousel">
      <div
        @click="goDetails(item)"
        v-for="(item, index) in teacherList"
        :key="index"
        :id="`viesww${index}`"
        class="swiperItem"
      >
        <div
          class="teachers"
          :style="`background-image:url(${item.terImg});background-size: 100% 100%;`"
        >
          <div class="te-detail">
            <div class="detail-text">
              {{ item.graduateName }}、{{ item.majorName }}
            </div>
            <div class="detail-content" v-html="item.profile"></div>
          </div>
          <div class="te-tips">
            <div class="te-name">{{ item.nickname }}</div>
            <div class="te-text ellipsis">
              {{ item.graduateName }}、{{ item.majorName }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/css/common.css";
import { BaseClient } from "@/api/baseCon";
const baseClient = new BaseClient();
export default {
  components: {},
  data() {
    return {
      total: "",
      teacherList: [],
      pageNum: 1,
      pageSize: 4,
    };
  },
  async created() {
    let params = {
      pageSize: this.pageSize,
      pageNum: 1
    };
    await baseClient
      .selectPCPageList(params)
      .then((res) => {
        if (res.data && res.data.rows) {
          this.teacherList = res.data.rows;
          this.total = res.data.total;
        } else {
          this.teacherList = [];
        }
      });
  },
  methods: {
    goDetails(item) {
      let routeUrl = this.$router.resolve({
        path: `/faculty/teacherDetail`,
        query: {
          id: item.id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    tonext(page) {
      this.pageNum = page;
      let params = {
        pageSize: this.pageSize,
        pageNum: page
      };
      baseClient
        .selectPCPageList(params)
        .then((res) => {
          if (res.data && res.data.rows) {
            this.teacherList = res.data.rows;
            this.total = res.data.total;
          } else {
            this.teacherList = [];
          }
        });
    },
    toprev(page) {
      this.pageNum = page;
      let params = {
        pageSize: this.pageSize,
        pageNum: page
      };
      baseClient
        .selectPCPageList(params)
        .then((res) => {
          if (res.data && res.data.rows) {
            this.teacherList = res.data.rows;
            this.total = res.data.total;
          } else {
            this.teacherList = [];
          }
        });
    },
  },
};
</script>
<style>
.el-popover {
  overflow: hidden;
  padding: 0px;
}
</style>
<style lang="less" scoped>
.two-box {
  width: 100%;
  height: 588px;
  background: #ffffff;
  padding-top: 60px;
  .title {
    width: 1220px;
    margin: auto;
    height: 23px;
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    p {
      font-size: 24px;
      font-family: Microsoft YaHei-Bold, Microsoft YaHei;
      font-weight: bold;
      color: #333333;
    }
    span {
      width: auto;
      height: auto;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #a8abbe;
      cursor: pointer;
    }
  }
  .carousel {
    display: flex;
    width: 1220px;
    margin: auto;
    .teachers {
      position: relative;
      z-index: 22;
      width: 275px;
      height: 412px;
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      margin-right: 40px;
      &:hover {
        .te-detail {
          display: block !important;
        }
      }
      .te-tips {
        position: absolute;
        bottom: 0px;
        width: 100%;
        left: 0px;
        height: 54px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 0px 0px 4px 4px;
        display: flex;
        align-items: center;
        z-index: 10;
        padding: 0px 20px;
        .te-name {
          font-size: 20px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 20px;
          flex-shrink: 0;
          margin-right: 8px;
        }
        .te-text {
          font-size: 14px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 14px;
          height: 14px;
          margin-top: 5px;
        }
      }
      .te-detail {
        position: absolute;
        display: none;
        top: 0px;
        left: 0px;
        bottom: 0px;
        width: 100%;
        background: url("https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/homeThree/teacher.png") 100% 100%;
        z-index: 100;
        padding: 48px 32px;
        overflow: hidden;
        .detail-text {
          font-size: 18px;
          font-family: Microsoft YaHei-Bold, Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 26px;
        }
        .detail-content {
          font-size: 14px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
          margin-top: 24px;
        }
      }
    }
  }
}
</style>
